var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "compare-products-popup" }, [
    _c("div", { staticClass: "modal", class: _vm.open ? "show fade" : "" }, [
      _c("div", { staticClass: "modal-dialog container-fluid" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "mt-4" }, [
            _c("div", { staticClass: "pop-up-modal-block" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "p",
                  { staticClass: "pop-up-modal-header secondary-heading" },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm.$resourceString["product.details.compare.title"]
                        ) +
                        "\n              "
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "wf-modal-button-close btn button-full",
                    attrs: { type: "button" },
                    on: { click: _vm.closeModal }
                  },
                  [
                    _c("span", {
                      staticClass:
                        "png-icon png-icon-icons-symbols--k-txtclose",
                      attrs: { "aria-label": "Close modal" }
                    })
                  ]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "modal-body" }, [
                _c("div", { staticClass: "row mt-1 mb-5" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-4 col-12" }, [
                        _c("p", { staticClass: "swatch-count" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.getCompareProducts.length) +
                              "\n                        " +
                              _vm._s(
                                _vm.$resourceString[
                                  "product.details.compare.selectedswatches"
                                ]
                              ) +
                              "\n                      "
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "pop-up-left-btn-group row w-100 text-right justify-content-center justify-content-md-end"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "col btn btn-white border-dark mt-1 mb-2 mx-2",
                                on: { click: _vm.removeAllCompareProduct }
                              },
                              [
                                _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString["common.removeAll"]
                                      ) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--k-close"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "col btn btn-white border-dark mt-1 mb-2 mx-2",
                                on: { click: _vm.copyComparisonUrl }
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mr-3" },
                                  [
                                    _vm.flash
                                      ? [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "common.linkCopiedText"
                                                ]
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                      : [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(
                                                _vm.$resourceString[
                                                  "common.copyLinkButtonText"
                                                ]
                                              ) +
                                              "\n                            "
                                          )
                                        ]
                                  ],
                                  2
                                ),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--k-link"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "col download-action-button btn btn-white border-dark mt-1 mb-2 mx-2",
                                on: { click: _vm.downloadProducts }
                              },
                              [
                                _c("span", { staticClass: "mr-3" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString["common.download"]
                                      ) +
                                      "\n                          "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--k-btn-download"
                                })
                              ]
                            ),
                            _vm._v(" "),
                            _vm.allowPdfRender
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "col download-action-button btn btn-white border-dark mt-1 mb-2 mx-2",
                                    on: { click: _vm.pdfDownload }
                                  },
                                  [
                                    _c("span", { staticClass: "mr-3" }, [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.$resourceString[
                                              "product.search.pdf.download.button.title"
                                            ]
                                          ) +
                                          "\n                          "
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "png-icon png-icon-icons-glyph--k-btn-download"
                                    })
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "col pop-up-add-to-cart-button btn btn-primary mt-1 mb-2 mx-2",
                                attrs: {
                                  type: "button",
                                  disabled: _vm.disableAddToCart
                                },
                                on: { click: _vm.addToCart }
                              },
                              [
                                _c("span", {
                                  staticClass:
                                    "png-icon png-icon-icons-glyph--ko-my-basket"
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "ml-2" }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "common.addtobasket"
                                        ]
                                      ) +
                                      "\n                          "
                                  )
                                ])
                              ]
                            )
                          ]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-12 w-100 h-100" },
                    [
                      !_vm.fetchingCompareProducts &&
                      _vm.getCompareProducts.length > 0
                        ? _c(
                            "VueSlickCarousel",
                            _vm._b(
                              {
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "nextArrow",
                                      fn: function() {
                                        return [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "custom-arrow-next",
                                              attrs: { type: "button" }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "png-icon png-icon-icons-glyph--k-chevron-right"
                                              })
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    },
                                    {
                                      key: "prevArrow",
                                      fn: function() {
                                        return [
                                          _c(
                                            "button",
                                            {
                                              staticClass: "custom-arrow-prev",
                                              attrs: { type: "button" }
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "png-icon png-icon-icons-glyph--k-chevron-left"
                                              })
                                            ]
                                          )
                                        ]
                                      },
                                      proxy: true
                                    }
                                  ],
                                  null,
                                  false,
                                  2598201106
                                )
                              },
                              "VueSlickCarousel",
                              _vm.settings,
                              false
                            ),
                            [
                              _vm._v(" "),
                              _vm._v(" "),
                              _vm._l(_vm.getCompareProducts, function(
                                item,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: item.sellingStyleNumber,
                                    staticClass: "compare-products"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wrapper-compare-item px-md-3"
                                      },
                                      [
                                        _c("div", { staticClass: "d-flex" }, [
                                          !item.selectedColor.samplesInfo
                                            .length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row pl-2 icon-container"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "mx-2 mb-2",
                                                      on: {
                                                        mouseover: function(
                                                          $event
                                                        ) {
                                                          return _vm.mouseover(
                                                            index + "-compare"
                                                          )
                                                        },
                                                        mouseleave:
                                                          _vm.mouseleave
                                                      }
                                                    },
                                                    [
                                                      _c("span", {
                                                        staticClass:
                                                          "png-icon png-icon-icons-symbols--r-txtinfo"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !item.selectedColor.samplesInfo
                                            .length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  directives: [
                                                    {
                                                      name: "show",
                                                      rawName: "v-show",
                                                      value:
                                                        index + "-compare" ==
                                                        _vm.showCard,
                                                      expression:
                                                        "index + '-compare' == showCard"
                                                    }
                                                  ],
                                                  staticClass:
                                                    "rating-content-card m-0",
                                                  attrs: { id: "hovercard" },
                                                  on: {
                                                    mouseover: function(
                                                      $event
                                                    ) {
                                                      return _vm.mouseover(
                                                        index + "-compare"
                                                      )
                                                    },
                                                    mouseleave: _vm.mouseleave
                                                  }
                                                },
                                                [
                                                  !item.selectedColor
                                                    .samplesInfo.length > 0
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "description text-uppercase"
                                                        },
                                                        [
                                                          _c("strong", [
                                                            _vm._v(
                                                              "\n                                STOCK Error\n                              "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "mb-0"
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .$resourceString[
                                                                      "pages.basket.errors.noavailablesize"
                                                                    ]
                                                                  ) +
                                                                  "\n                              "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "a",
                                            {
                                              staticClass:
                                                "btn btn-white px-0 my-1 ml-auto",
                                              on: {
                                                click: function($event) {
                                                  return _vm.removeCompareProduct(
                                                    item.sellingStyleNumber
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "mr-3" },
                                                [
                                                  _vm._v(
                                                    "\n                              " +
                                                      _vm._s(
                                                        _vm.$resourceString[
                                                          "common.remove"
                                                        ]
                                                      ) +
                                                      "\n                            "
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "png-icon png-icon-icons-glyph--k-close"
                                              })
                                            ]
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "pop-up-compare-div-image mb-3"
                                          },
                                          [
                                            _c("img", {
                                              staticClass:
                                                "image-compare w-100",
                                              attrs: {
                                                alt: "00100",
                                                src:
                                                  item.selectedColor.imagePath
                                              },
                                              on: {
                                                error: _vm.handleImageError
                                              }
                                            })
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "dl",
                                          {
                                            staticClass:
                                              "description text-uppercase"
                                          },
                                          [
                                            _c("div", [
                                              _c("dt", [
                                                _c("u", [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.selectedColor
                                                        .colorName
                                                    )
                                                  )
                                                ])
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _vm._v(
                                                  "\n                              " +
                                                    _vm._s(
                                                      item.selectedColor
                                                        .colorNumber
                                                    ) +
                                                    "\n                            "
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c("dt", [
                                                _vm._v(
                                                  "\n                              " +
                                                    _vm._s(
                                                      _vm.$resourceString[
                                                        "product.details.specifications.product.style"
                                                      ]
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _vm._v(
                                                  "\n                              " +
                                                    _vm._s(
                                                      item.sellingStyleName
                                                    ) +
                                                    "\n                            "
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c("div", [
                                              _c("dt", [
                                                _vm._v(
                                                  "\n                              " +
                                                    _vm._s(
                                                      _vm.$resourceString[
                                                        "product.details.specifications.product.collection"
                                                      ]
                                                    ) +
                                                    "\n                            "
                                                )
                                              ]),
                                              _vm._v(" "),
                                              _c("dd", [
                                                _vm._v(
                                                  "\n                              " +
                                                    _vm._s(item.collection) +
                                                    "\n                            "
                                                )
                                              ])
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "swatches-part" },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "swatch-title text-uppercase"
                                                  },
                                                  [
                                                    _c("b", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.colors.length
                                                        )
                                                      )
                                                    ]),
                                                    _vm._v(
                                                      "\n                              " +
                                                        _vm._s(
                                                          _vm.$resourceString[
                                                            "product.details.room.scene.swatch.colors"
                                                          ]
                                                        ) +
                                                        "\n                            "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "swatch-image-section row"
                                                  },
                                                  _vm._l(item.colors, function(
                                                    color
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key:
                                                          color.colorName +
                                                          color.colorNumber,
                                                        staticClass:
                                                          "col-4 swatch-image-item px-1"
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "btn wf-product-room-scene-color-item-button",
                                                            class:
                                                              color.colorNumber ===
                                                              item.selectedColor
                                                                .colorNumber
                                                                ? "wf-product-room-scene-color-item-button-active"
                                                                : "wf-product-room-scene-color-item-button-disabled",
                                                            attrs: {
                                                              type: "button"
                                                            },
                                                            on: {
                                                              click: function(
                                                                $event
                                                              ) {
                                                                return _vm.updateColor(
                                                                  index,
                                                                  color
                                                                )
                                                              }
                                                            }
                                                          },
                                                          [
                                                            _c("img", {
                                                              staticClass:
                                                                "w-100 h-100",
                                                              attrs: {
                                                                src: _vm.$helpers.getColorThumbnailImageUrl(
                                                                  item.sellingStyleNumber,
                                                                  color.colorNumber
                                                                ),
                                                                alt: ""
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.handleImageError
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "wf-product-room-scene-color-item-name"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                    " +
                                                                    _vm._s(
                                                                      color.colorName +
                                                                        (color.customIsDisclaimerColor
                                                                          ? "*"
                                                                          : "")
                                                                    ) +
                                                                    "\n                                    "
                                                                ),
                                                                _c("br"),
                                                                _vm._v(
                                                                  "\n                                    " +
                                                                    _vm._s(
                                                                      color.colorNumber
                                                                    ) +
                                                                    "\n                                  "
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  }),
                                                  0
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.viewMore,
                                                    expression: "viewMore"
                                                  }
                                                ],
                                                attrs: { id: "viewMoreCard" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "specification-part mt-4"
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "label my-2"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                " +
                                                            _vm._s(
                                                              _vm
                                                                .$resourceString[
                                                                "product.details.specifications.specifications"
                                                              ]
                                                            ) +
                                                            "\n                              "
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    item.inventorySubType
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.product.category"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.inventorySubType
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.inventoryType
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.product.type"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.inventoryType
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.secondaryBacking
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.secondary.backing"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.secondaryBacking
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.construction
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.construction"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.construction
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.testResults
                                                      .tarrClassification
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.wear.rating"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item
                                                                    .testResults
                                                                    .tarrClassification
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.dyeMethod
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.dye.method"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.dyeMethod
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.fiber
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.fiber"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  item.fiber
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    item.areaPerCarton
                                                      ? _c("div", [
                                                          _c("dt", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.squareyards"
                                                                  ]
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("dd", [
                                                            _vm._v(
                                                              "\n                                  " +
                                                                _vm._s(
                                                                  Math.round(
                                                                    item
                                                                      .areaPerCarton
                                                                      .metric
                                                                      .formattedValue *
                                                                      100
                                                                  ) / 100
                                                                ) +
                                                                "\n                                "
                                                            )
                                                          ])
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                item.selectedColor
                                                  .colorCustomData.pdqId
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "pdq-part mt-4"
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "label my-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.pdq.details"
                                                                  ]
                                                                ) +
                                                                "\n                              "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("dd", {
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              item.pdqDetails
                                                            )
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.recyclability
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "sustain-part mt-4"
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "label my-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.sustainability"
                                                                  ]
                                                                ) +
                                                                "\n                              "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("dt", [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                _vm
                                                                  .$resourceString[
                                                                  "product.details.specifications.recyclability"
                                                                ]
                                                              ) +
                                                              "\n                              "
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("dd", [
                                                          _vm._v(
                                                            "\n                                " +
                                                              _vm._s(
                                                                item.recyclability
                                                              ) +
                                                              "\n                              "
                                                          )
                                                        ])
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                item.attributes
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "third-party-part mt-4"
                                                      },
                                                      [
                                                        _c(
                                                          "h3",
                                                          {
                                                            staticClass:
                                                              "label my-2"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                " +
                                                                _vm._s(
                                                                  _vm
                                                                    .$resourceString[
                                                                    "product.details.specifications.third.party.certificates"
                                                                  ]
                                                                ) +
                                                                "\n                              "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item.attributes,
                                                          function(attribute) {
                                                            return item
                                                              .attributes
                                                              .length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    key:
                                                                      attribute.name,
                                                                    staticClass:
                                                                      "third-party-items mb-2"
                                                                  },
                                                                  [
                                                                    attribute.pdfLink
                                                                      ? _c(
                                                                          "dt",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                  " +
                                                                                _vm._s(
                                                                                  attribute.name
                                                                                ) +
                                                                                "\n                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    attribute.pdfLink
                                                                      ? _c(
                                                                          "dd",
                                                                          [
                                                                            _c(
                                                                              "u",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                    " +
                                                                                    _vm._s(
                                                                                      attribute.status
                                                                                    ) +
                                                                                    "\n                                  "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm._l(
                                                          item.certifications,
                                                          function(
                                                            certification
                                                          ) {
                                                            return item
                                                              .certifications
                                                              .length > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    key:
                                                                      certification.name,
                                                                    staticClass:
                                                                      "third-party-items mb-2"
                                                                  },
                                                                  [
                                                                    certification.pdfLink
                                                                      ? _c(
                                                                          "dt",
                                                                          [
                                                                            _vm._v(
                                                                              "\n                                  " +
                                                                                _vm._s(
                                                                                  certification.name
                                                                                ) +
                                                                                "\n                                "
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(" "),
                                                                    certification.pdfLink
                                                                      ? _c(
                                                                          "dd",
                                                                          [
                                                                            _c(
                                                                              "u",
                                                                              [
                                                                                _vm._v(
                                                                                  "\n                                    " +
                                                                                    _vm._s(
                                                                                      certification.status
                                                                                    ) +
                                                                                    "\n                                  "
                                                                                )
                                                                              ]
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          }
                                                        )
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e()
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "view-more-and-less-btn pt-4 px-5" },
                        [
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.viewMore,
                                  expression: "!viewMore"
                                }
                              ]
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "view_more_pop-up",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateView(true)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.search.side.filters.view.more"
                                        ]
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", {
                                    staticClass:
                                      "png-icon png-icon-icons-glyph--k-btn-expand-ol wf-product-refinement-list-header-toggle-active"
                                  })
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.viewMore,
                                  expression: "viewMore"
                                }
                              ]
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "view_less_pop-up",
                                  on: {
                                    click: function($event) {
                                      return _vm.updateView(false)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(
                                        _vm.$resourceString[
                                          "product.search.side.filters.view.less"
                                        ]
                                      ) +
                                      "\n                        "
                                  ),
                                  _c("span", {
                                    staticClass:
                                      "png-icon png-icon-icons-glyph--k-btn-minus-active wf-product-refinement-list-header-toggle-inactive"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { position: "relative" } },
              [
                _c("pc-search-pdf-popup", {
                  attrs: { showPopup: _vm.showPdfPopup },
                  on: { close: _vm.closePdfPopup }
                })
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }